<template>
  <v-col>
    <v-row>
      <v-col no-gutters class="detail-col" v-if="!isMbMode">
        <v-card tile>
          <v-toolbar color="success" dark class="mb-4" dense>
            <v-toolbar-title>以下の内容を投稿します。</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
              <v-divider inset vertical></v-divider>
              <v-btn text @click="postTwitter()">投稿</v-btn>
              <v-divider inset vertical></v-divider>
              <v-btn text @click="cancelTwitter()">キャンセル</v-btn>
              <v-divider inset vertical></v-divider>
            </v-toolbar-items>
          </v-toolbar>
          <v-sheet>
            <div
              class="success--text text-h6 mt-2 ml-2 font-weight-bold"
              v-text="text"
            ></div>
            <v-divider class="pb-1"></v-divider>
            <v-textarea
              outlined
              rows="3"
              class="mx-1"
              color="success"
              v-model="twitterText"
            ></v-textarea>
          </v-sheet>
          <v-sheet v-show="twitterCapture.length !== 0">
            <div
              class="success--text text-h6 ml-2 font-weight-bold"
              v-text="image"
            ></div>
            <v-divider class="pb-2"></v-divider>
            <v-container class="overflow-y-auto">
              <v-row style="height: 45vh;" v-if="isMbMode">
                <v-col
                  v-for="(capture, idx) in twitterCapture"
                  :key="`capture-${idx}`"
                  cols="12"
                >
                  <v-img
                    class="capture-width"
                    :src="capture.capData"
                    :captureType="capture.type"
                  ></v-img>
                </v-col>
              </v-row>
              <v-row
                style="height: 45vh;"
                v-else-if="twitterCapture.length === 1"
              >
                <v-col
                  v-for="(capture, idx) in twitterCapture"
                  :key="`capture-${idx}`"
                  cols="5"
                  class="mx-4"
                >
                  <v-img
                    class="capture-width"
                    :src="capture.capData"
                    :captureType="capture.type"
                  ></v-img>
                </v-col>
              </v-row>
              <v-row style="height: 45vh;" v-else>
                <v-col
                  v-for="(capture, idx) in twitterCapture"
                  :key="`capture-${idx}`"
                  cols="3"
                  class="mx-4"
                >
                  <v-img
                    class="capture-width"
                    :src="capture.capData"
                    :captureType="capture.type"
                  ></v-img>
                </v-col>
              </v-row>
            </v-container>
          </v-sheet>
        </v-card>
        <v-overlay v-show="twitterLoading">
          <v-progress-circular
            :indeterminate="loading.pc.inder"
            :rotate="loading.pc.rotate"
            :size="loading.pc.size"
            :width="loading.pc.width"
            color="success"
          ></v-progress-circular>
        </v-overlay>
      </v-col>
      <v-col class="detail-col" v-if="isMbMode">
        <v-card tile>
          <v-toolbar color="success" dark class="mb-4" height="40px">
            <v-toolbar-title style="font-size: 1rem;"
              >以下の内容を投稿します。</v-toolbar-title
            >
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-sheet>
            <div
              class="success--text ml-2 font-weight-bold"
              style="font-size: 1rem;"
              v-text="text"
            ></div>
            <v-divider class="pb-1"></v-divider>
            <v-textarea
              outlined
              class="mx-1"
              rows="4"
              style="font-size: 0.9rem;"
              color="success"
              v-model="twitterText"
            ></v-textarea>
          </v-sheet>
          <v-sheet v-show="twitterCapture.length !== 0">
            <div
              class="success--text ml-2 font-weight-bold"
              style="font-size: 1rem;"
              v-text="image"
            ></div>
            <v-divider></v-divider>
            <v-container class="overflow-y-auto pt-0">
              <v-row style="height: 35vh;">
                <v-col
                  v-for="(capture, idx) in twitterCapture"
                  :key="`capture-${idx}`"
                  cols="12"
                >
                  <v-img
                    class="capture-width"
                    :src="capture.capData"
                    :captureType="capture.type"
                  ></v-img>
                </v-col>
              </v-row>
            </v-container>
          </v-sheet>
          <v-sheet>
            <v-toolbar color="success" dark class="mb-4" height="40px">
              <v-toolbar-items>
                <v-divider inset vertical></v-divider>
                <v-btn text @click="postTwitter()">投稿</v-btn>
                <v-divider inset vertical></v-divider>
                <v-btn text @click="cancelTwitter()">キャンセル</v-btn>
                <v-divider inset vertical></v-divider>
              </v-toolbar-items>
            </v-toolbar>
          </v-sheet>
        </v-card>
        <v-overlay v-show="twitterLoading">
          <v-progress-circular
            :indeterminate="loading.mb.inder"
            :rotate="loading.mb.rotate"
            :size="loading.mb.size"
            :width="loading.mb.width"
            color="success"
          ></v-progress-circular>
        </v-overlay>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import twitJs from "../../lib/twitter";
export default {
  name: "twitter-check",
  data() {
    return {
      text: "投稿内容",
      image: "投稿画像",
      twitterText: twitJs.getTwitterText(),
      loading: {
        pc: {
          inder: true,
          rotate: 0,
          size: 100,
          width: 10,
        },
        mb: {
          inder: true,
          rotate: 0,
          size: 50,
          width: 5,
        },
      },
    };
  },
  beforeCreate() {
    this.$store.commit("sns/setShowTwitterCheck", true);
  },
  mounted() {
    this.getOauthVerifier();
    this.getAccessToken();
  },
  computed: {
    twitterCapture: {
      get() {
        let twitterCapture = [];
        if (twitJs.getTwitterCapture() !== null) {
          twitterCapture.push(twitJs.getTwitterCapture());
        }
        if (twitJs.getTwitterCaptureCross() !== null) {
          twitterCapture.push(twitJs.getTwitterCaptureCross());
        }
        if (twitJs.getTwitterCaptureGraph() !== null) {
          twitterCapture.push(twitJs.getTwitterCaptureGraph());
        }
        return twitterCapture;
      },
    },
    twitterLoading: {
      get() {
        return this.$store.state.sns.twitterLoading;
      },
    },
    isMbMode: {
      get() {
        if (window.innerWidth < window.innerHeight) {
          return true;
        } else {
          return false;
        }
      },
    },
  },
  methods: {
    /** Twitter OauthVerifier取得 */
    getOauthVerifier() {
      this.$log.debug("[TwitterCheck] getOauthVerifier()");
      let oauthToken = this.$route.query["oauth_token"];
      let oauthVerifier = this.$route.query["oauth_verifier"];

      this.$store.commit("sns/setOauthToken", oauthToken);
      this.$store.commit("sns/setOauthVerifier", oauthVerifier);
    },
    /** Twitter アクセストークン取得 */
    getAccessToken() {
      this.$log.debug("[TwitterCheck] getAccessToken()");
      setTimeout(() => {
        this.$store.dispatch("sns/getAccessToken");
      }, 1000);
    },
    uploadTwitterImage() {
      this.$log.debug("[TwitterCheck] uploadTwitterImage()");
      setTimeout(() => {
        this.$store.dispatch("sns/uploadTwitterImage", {
          text: this.twitterText,
        });
      }, 1000);
    },
    /** Twitter投稿 */
    postTwitter() {
      this.$log.debug("[TwitterCheck] postTwitter()");
      this.$store.commit("sns/setTwitterLoading", true);
      this.uploadTwitterImage();
    },
    getShowTwitterCheck() {
      this.$log.debug("[TwitterCheck] getShowTwitterCheck()");
      this.$store.commit("sns/setShowTwitterCheck", true);
    },
    /** 投稿をキャンセル */
    cancelTwitter() {
      this.$log.debug("[TwitterCheck] postTwitter()");
      twitJs.resetTwitterStorage();
      window.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.capture-width {
  &[captureType="obs"] {
    width: 25%;
  }
}
</style>
